angular.module('tgaAdmin')
  .service('supportService', ['$http', 'envService',
    function ($http, envService) {
      const serverAddress = envService.read('serverAddress');

      function sendMessage(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}support`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getAgreement() {
        return $http({
          method: 'GET',
          url: `${serverAddress}support/agreement`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUserAgreements(agreement_types, user_id, hub_id) {
        return $http({
          method: 'GET',
          url: `${serverAddress}support/useragreements`,
          params: {
            'agreement_type[]': agreement_types,
            user_id,
            hub_id,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function storeUserAgreements(agreement_ids, user_id, hub_id) {
        return $http({
          method: 'POST',
          url: `${serverAddress}support/useragreements`,
          data: {
            agreement_id: agreement_ids,
            user_id,
            hub_id,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        sendMessage,
        getAgreement,
        getUserAgreements,
        storeUserAgreements,
      });
    }]);
